class RestaurantList extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables
		this.antiSpam = false;
		this.type = 'get';

		this.translations = {
			'fr': {
				'dining': 'Salle à manger',
				'breakfast': 'Déjeuner',
				'delivery': 'Livraison'
			},
			'en': {
				'dining': 'Dining room',
				'breakfast': 'Breakfast',
				'delivery': 'Delivery'
			}
		};

		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition((position) => this.setPosition(position));
		}
	}

	init() {
		this.addEvents();
	}

	addEvents() {
		Me.dispatch.subscribe('update.restaurant.list', (e, params) => this.updateList(e,params));
		Me.dispatch.subscribe('loading.restaurant.list', (e, params) => this.handleLoading(e, params));
	}

	removeEvents() {
		Me.dispatch.unsubscribe('update.restaurant.list', (e, params) => this.updateList(e,params));
		Me.dispatch.unsubscribe('loading.restaurant.list');
	}

	handleLoading(e, params){
		this.$el.addClass('loading-data');
	}

	updateList(e, params){
		let source   = document.getElementById(this.options.template).innerHTML;
		let template = Handlebars.compile(source);

		params.data = this.parseData(params.data);

		let html    = template({'emplacement': params.data});

		this.$el.html(html);
		this.$el.removeClass('loading-data');
	}

	//  If geoloc allowed, these functions will be called
	setPosition(position){
		if(this.antiSpam) {return;}
		this.antiSpam = true;

		let lat = position.coords.latitude;
		let lng = position.coords.longitude;

		this.searchPosition = {
			'lat': lat,
			'lng': lng
		};

		this.handleAjax({lat:lat, lng:lng});
	}

	getUrlVars() {
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for(var i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}

	handleAjax(data){
		var currentPage = this.getUrlVars()['page'];
		if(currentPage === undefined){
			currentPage = '1';
		}

		let options = {
			method: this.type,
			url: this.$el.attr('data-action') + '?lat=' + data.lat + '&lng=' + data.lng + '&lang=' + SETTINGS.LANGUAGE + '&page=' + currentPage,
			dataType: 'json',
			success: $.proxy(this.ajaxSuccess, this),
			error: $.proxy(this.ajaxError, this)
		};

		Me.dispatch.emit('loading.restaurant.list');
		$.ajax(options);
	}

	ajaxSuccess(data){
		Me.dispatch.emit('update.restaurant.list', this, {'data': data, 'position': this.searchPosition});
        this.antiSpam = false;
	}

	ajaxError(error){
		this.antiSpam = false;
	}

	parseData(location){
		$.each(location, (index, value)=>{
			$.each(value.schedule.now, (categoryIndex, categoryValue)=>{
				categoryValue.categoryName = this.translations[SETTINGS.LANGUAGE][categoryIndex]
			});
		});

		return location;
	}
}

